import { SolutionTag } from '@luminovo/api-contracts';

import { Solution } from '../types';

export function hasSolutionTag(solution: Pick<Solution, 'solutionTags'>, solutionTag: SolutionTag): boolean {
    return solution.solutionTags.some(({ tag }) => tag === solutionTag);
}
